/* eslint-disable complexity */
/* eslint-disable max-statements */
$(document).ready(function() {
  ACC.omniture = {
    trackConversion: function(name, description) {
      philips.analytics.trackConversion({
        name: name,
        description: description
      });
    }
  };

  function trackAjax(trackObject) {
    if (typeof philips.analytics !== 'undefined') {
      philips.analytics.trackAjax(trackObject);
    }
  }

  function trackNav(navdest, navid, navtype) {
    if (typeof philips.analytics !== 'undefined') {
      philips.analytics.trackNavNena({
        navdest: navdest,
        navid: navid,
        navtype: navtype
      });
    }
  }

  // Signout
  $(document).on('click', '.ph-logout', function() {
    ACC.omniture.trackConversion('interaction', 'menu:sign_out');
  });

  // Order history
  $(document).on('click', '.ph-orderhistory', function() {
    ACC.omniture.trackConversion('interaction', 'click:view_order_history');
  });


  // Faq
  $(document).on('click', '.ph-faq_icon', function() {
    ACC.omniture.trackConversion('interaction', 'menu:faq');
  });

  // Switch customer
  $(document).on('click', '.ph-switchcustomer', function() {
    ACC.omniture.trackConversion('interaction', 'menu:switch_customer');
  });

  // Generate reports
  $(document).on('click', '.ph-generatereports', function() {
    ACC.omniture.trackConversion('interaction', 'menu:generatereports');
  });

  // Profile
  $(document).on('click', '.ph-profilepage', function() {
    ACC.omniture.trackConversion('interaction', 'menu:profile');
  });

  // Payment balance
  $(document).on('click', '.ph-quickorder', function() {
    ACC.omniture.trackConversion('interaction', 'menu:quickorder');
  });

  // Quickorder
  $(document).on('click', '.ph-paymentbalance', function() {
    ACC.omniture.trackConversion('interaction', 'menu:paymentbalance');
  });

  // Shoppinglist
  $(document).on('click', '.ph-shoppinglist', function() {
    ACC.omniture.trackConversion('interaction', 'menu:shoppinglist');
  });

  // Quick order upload
  $('.fileImport').click(function() {
    ACC.omniture.trackConversion('interaction', 'quickorder:upload');
  });

  // Forgot password
  $(document).on('click', '.password-forgotten', function() {
    ACC.omniture.trackConversion('interaction', 'link:forgot_your_password');
  });

  // Quick order download
  $(document).on('click', '.ph-quickorderdownload', function() {
    ACC.omniture.trackConversion('interaction', 'quickorder:download');
  });

  // My Account
  $(document).on('click', '.ph-myaccount', function() {
    ACC.omniture.trackConversion('interaction', 'menu:my_account');
  });

  // Create new shopping list (Shopping list page)
  $(document).on('click', '.createnewlist-btn', function() {
    ACC.omniture.trackConversion('interaction', 'shopping_list:creation');
  });

  // Continue to checkout (Cart page)
  $(document).on('click', '.chekoutAddressUrl', function() {
    ACC.omniture.trackConversion('interaction', 'button:checkout');
  });

  // Banner call-to-action (CTA) button (eg shavers on homepage)
  $(document).on('click', '.ph-banner', function() {
    var bannername = $(this).attr('title');

    ACC.omniture.trackConversion('interaction', 'banner:button:' + bannername);
  });

  // Change delivery date (Cart page)
  $('.phi-datepicker').change(function() {
    ACC.omniture.trackConversion('interaction', 'delivery_date:change');
  });

  // Add Product from cart
  $(document).on('click', '.addToCartButton', function() {
    if ($('.quantity-balloon').length > 0) {
      trackAjax({
        events: 'scAdd',
        products: $(this).attr('data-ctv'),
        type: 'o'
      });
    } else {
      trackAjax({
        events: 'scOpen,scAdd',
        products: $(this).attr('data-ctv'),
        type: 'o'
      });
    }
  });

  // Remove Product from cart
  $(document).on('click', '.ph-RemoveProduct', function() {
    trackAjax({
      events: 'scRemove',
      products: $(this).attr('data-ctv'),
      type: 'o'
    });
  });

  // Shopping order Add to cart
  $(document).on('click', '.ph-addtocart', function() {
    var arr = [];

    $('.ph-ctv').each(function() {
      if ($(this).attr('data-ctv') !== '') {
        arr.push($(this).attr('data-ctv'));
      }
    });

    if ($('.quantity-balloon').length > 0) {
      trackAjax({
        events: 'scAdd',
        products: arr.toString(),
        type: 'o'
      });
    } else {
      trackAjax({
        events: 'scOpen,scAdd',
        products: arr.toString(),
        type: 'o'
      });
    }
  });

  // Quick order Add to cart
  $(document).on('click', '.ph-quick-order-button', function() {
    var arr = [];

    /* eslint-disable sonarjs/no-identical-functions */
    $('.product-hidden-code').each(function() {
      if ($(this).attr('data-ctv') !== '') {
        arr.push($(this).attr('data-ctv'));
      }
    });/* eslint-enable sonarjs/no-identical-functions */

    if ($('.quantity-balloon').length > 0) {
      trackAjax({
        pagename: 'quick_order',
        events: 'scAdd',
        products: arr.toString(),
        type: 'o'
      });
    } else {
      trackAjax({
        pagename: 'quick_order',
        events: 'scOpen,scAdd',
        products: arr.toString(),
        type: 'o'
      });
    }
  });

  // Category navigation
  $(document).on('click', '.ph-rootnav', function() {
    trackNav($(this).text().trim(), 'header', 'nena');
  });

  // Change quantity
  $('.qty').change(function() {
    var entryNum = $(this).parent().find('input[name=entryNumber]').val();
    /* eslint-disable init-declarations */
    var greeting;
    /* eslint-enable init-declarations */
    var $form = $('#updateCartForm' + entryNum);
    var initialCartQuantity = $form.find('input[name=initialQuantity]').val();
    var newCartQuantity = $form.find('input[name=quantity]').val();

    if (initialCartQuantity < newCartQuantity) {
      greeting = 'Increase';
    } else {
      greeting = 'Decrease';
    }

    /* eslint-disable no-useless-concat */
    ACC.omniture.trackConversion('interaction', $(this).attr('data-ctv') + ':' + 'quantity:' + greeting);
    /* eslint-enable no-useless-concat */
  });

  // Update password validation
  function updatePassword(txt) {
    if (txt === 'Positive') {
      philips.analytics.trackConversion({
        name: 'interaction',
        description: 'button:password_updated'
      });
    }
  }


  // Place order validation
  function placeOrder(txt) {
    if (txt === 'Positive') {
      philips.analytics.trackConversion({
        name: 'interaction',
        description: 'button:place_order'
      });
    }
  }

  function errorValidation(txt) {
    if (txt === 'Negative') {
      philips.analytics.trackConversion({
        name: 'validation_error',
        description: 'form.global.error'
      });
    }
  }

  // Login Page validation
  function userLogin(txt) {
    if (txt === 'Positive') {
      philips.analytics.trackConversion({
        name: 'user_login'
      });
    }
  }

  /* eslint-disable unicorn/explicit-length-check *//* eslint-disable max-len*/
  if ($('.template-pages-LoginPageTemplate').length > 0 && $('.alert').length && document.getElementsByClassName('alert')[0].classList[1] === 'negative') {
    errorValidation('Negative');
    /* eslint-enable unicorn/explicit-length-check*//* eslint-enable max-len*/
  }

  if ($('.page-shopSiteSelectionPage').length > 0 && $('#sold-to-selection-content').attr('data-attr') === 'true') {
    userLogin('Positive');
  }

  if ($('#updatePasswordForm').length > 0 || document.getElementsByClassName('error').length > 0) {
    errorValidation('Negative');
  }

  if ($('.template-pages-AccountPageTemplate').length > 0 && $('.my-account-container').attr('data-passwordsuccess') === 'true') {
    updatePassword('Positive');
  }

  if ($('.template-pages-LoginPageTemplate').length > 0 && $('.login_container').attr('data-password-success') === 'true') {
    updatePassword('Positive');
  }

  if ($('.page-singleStepCheckoutSummaryPage').length > 0 && document.getElementsByClassName('negative').length > 0) {
    errorValidation('Negative');
  }

  if ($('.page-orderConfirmationPage').length > 0 && $('.align-left').attr('data-placeorder') === 'true') {
    placeOrder('Positive');
  }

  // Quickorder validation
  function quickOrdertValidation(txt) {
    if (txt === 'Positive') {
      trackAjax({
        pagename: 'quick_order',
        events: 'scAdd',
        products: $(this).attr('data-ctv'),
        type: 'o'
      });
    }
  }

  if ($('.page-cartPage').length > 0 && $('#shopping-cart-content').attr('data-quickorder') === 'true') {
    quickOrdertValidation('Positive');
  }

  if ($('.page-quickOrder').length > 0 && document.getElementsByClassName('negative').length > 0) {
    errorValidation('Negative');
  }

  // Save Order
  $('.ph-saveorder').click(function() {
    ACC.omniture.trackConversion('interaction', 'button:save_order');
  });

  // Save update
  $('.ph-saveupdate').click(function() {
    ACC.omniture.trackConversion('interaction', 'update_personal_details');
  });

  // Update personal details
  $('.ph-upadatepersoanldetails').click(function() {
    ACC.omniture.trackConversion('interaction', 'click:update_personal_info');
  });

  // Order history download excel
  $('.ph-downloadreport__button').click(function() {
    ACC.omniture.trackConversion('download', 'excel');
  });

  // Payment balance report download excel
  $('.ph-pbreportdownload__button').click(function() {
    ACC.omniture.trackConversion('download', 'excel');
  });
  // Keybenefit tab click
  $('#ph-keybenefits').click(function() {
    philips.analytics.trackTab('key_benefits');
  });

  // Product detail tab click
  $('#ph-productdetails').click(function() {
    philips.analytics.trackTab('product_details');
  });

  // Product additional details tab click
  $('#ph-additionalinformation').click(function() {
    philips.analytics.trackTab('additional_information');
  });
  /* eslint-enable complexity */
  /* eslint-enable max-statements */


  // Clicking on result
  $('.ph-orderlist').click(function() {
    var $ordernumber = $(this).find('.ph-ornumber').html();
    var $rownumber = this.parentElement.rowIndex;
    var $orderType = 'Non_Standard_orders';

    if ($('#ph-selectedtab').val() === 'stdOrds') {
      $orderType = 'standard_orders';
    }

    ACC.omniture.trackConversion('interaction', $orderType + ':click:tab:' + $ordernumber + ':' + $rownumber);
  });

  // Clicking on Submit
  $('.phi-submitform').click(function() {
    var $ordernr = $('#orderNo').val();
    var $productcode = $('#productCode').val();
    var $ponumber = $('#purchaseOrderNumber').val();
    var orderCreatedToDate = $('.ph-todate').val();
    var orderCreatedFromDate = $('.ph-fromdate').val();
    var dateRange = orderCreatedToDate + '_' + orderCreatedFromDate;
    var $selectedCountry = $('#shippingStatus').children('option:selected').html().replace(/ /g, '_');

    if ($('#ph-selectedtab').val() === 'stdOrds') {
      ACC.omniture.trackConversion('interaction', 'Standard_orders:button:submit:' +
              $ordernr + '|' + $productcode + '|' + $ponumber + '|' + $selectedCountry + '|' + dateRange);
    } else {
      ACC.omniture.trackConversion('interaction', 'Non_Standard_orders:button:submit:' +
           $ordernr + '|' + $productcode + '|' + $ponumber + '|' + dateRange);
    }
  });

  // Replace $tabname with "standard_orders" or "non_standard_orders"
  $('.ph-reset').click(function() {
    var $orderType = 'Non_Standard_orders:';

    if ($('#ph-selectedtab').val() === 'stdOrds') {
      $orderType = 'Standard_orders:';
    }

    ACC.omniture.trackConversion('interaction', $orderType + 'button:reset');
  });
});

